<template>
    <div class="ManagementSKU">
        <div class="left">
          <el-button type="primary" @click="handleFenpei" style="margin-left: 10px;margin-bottom: 6px">分配</el-button>
            <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText"
                style="width: 90%; margin-left: 5%; margin-bottom: 5px;">
            </el-input>
            <el-tree
                :data="treeData"
                :props="treeProps"
                @node-click="handleNodeClick"
                :filter-node-method="filterNode"
                ref="tree"
                :highlight-current="highlight">
            </el-tree>
        </div>
        <div class="right">
            <div class="summary_complete_bag">
                <el-form :inline="true" label-width="114px" ref="selectForm" :model="selectForm">
                    <el-form-item label=" ">
                            <el-input v-model.trim="selectForm.input" style="width:430px;" clearable
                            placeholder="请输入 sku/spu/中文名称/英文名称"></el-input>
                        </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">搜索</el-button>
                        <el-button type="primary" @click="searchReset">重置</el-button>
                    </el-form-item>
                </el-form>

            </div>

            <div class="summary_content">
                <div class="summary_list">
                    <el-table
                    :data="summarylist"
                    style="width: 100%"
                    element-loading-text="拼命加载中"
                    v-loading="loading"
                    border
                    :header-cell-style="iscenter"
                    stripe height="700"
                    >
                        <el-table-column
                            align="center"
                            prop="id"
                            label="id">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="newSku"
                            width="150"
                            label="sku">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            width="130"
                            label="spu">
                            <template slot-scope="scope" v-if="scope.row.newSpu !== null">
                                <span>{{ scope.row.newSpu }}</span>
                                <span> * </span>
                                <span :style="{ color: 'red' }">{{ scope.row.count }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                            align="center"
                            prop="newSku"
                            label="newSku">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="newSpu"
                            label="newSpu">
                        </el-table-column> -->

                        <el-table-column
                            align="center"
                            width="120"
                            label="主图">
                            <template slot-scope="scope" v-if="scope.row.mainImageUrl">
                                <el-image style="width: 80px; height: 80px" :src="scope.row.mainImageUrl.split(',')[0]" fit="fill"
                                :preview-src-list="scope.row.mainImageUrl.split(',').concat(scope.row.attachedImageUrl.split(','))"
                                ></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="chineseProductName"
                            label="中文品名">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            width="120"
                            label="长*宽*高(cm)">
                            <template slot-scope="scope">
                                <div>
                                {{ scope.row.length }} * {{ scope.row.width }} * {{ scope.row.height }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="grossWeight"
                            label="毛重(g)">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="chineseName"
                            width="200"
                            label="中文名">
                        </el-table-column>

                        <el-table-column
                            align="center"
                            prop="englishName"
                            width="200"
                            label="英文名">
                        </el-table-column>

                        <el-table-column
                            align="center"
                            prop="color"
                            label="颜色">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="size"
                            label="尺寸">
                        </el-table-column>

                        <el-table-column
                            align="center"
                            width="160"
                            label="类目"
                            >
                            <template slot-scope="scope">
                                {{ getMergedCategories(scope.row) }}
                            </template>
                        </el-table-column>


                        <el-table-column
                            align="center"
                            prop="englishProductName"
                            label="英文品名">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            width="100"
                            prop="grossRevenue"
                            label="毛收入">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="grossRevenueRanking"
                            label="毛收入排名">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="salesVolume"
                            label="销量">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="salesVolumeRanking"
                            label="销量排名">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            width="100"
                            prop="orderGrossProfit"
                            label="订单毛利润">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            width="100"
                            prop="orderGrossProfitMargin"
                            label="订单毛利润率(%)">
                        </el-table-column>
                       <el-table-column label="操作" fixed="right" :width="100" align="center">
                            <template slot-scope="scope">
                                <el-dropdown @command="handleCommand($event, scope.row)">
                                <span class="el-dropdown-link">
                                    查看<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="a">编辑</el-dropdown-item>
                                </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </div>

            <div class="summary_pagenum_block">
                <div class="block">
                <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                    @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
                </div>
            </div>
        </div>

        <EditSKU ref="EditSKU" @fatherMethod="getTongTuoProducts"></EditSKU>

      <el-dialog
          title="分配"
          :visible.sync="isShowFenpei"
          width="700px"
          top="5vh"
          style="margin-top:20px;"
      >

        <el-form
            class="custom-form"
            ref="form"
            label-width="80px"
            label-position="right"
            style="padding: 0 24px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择部门">
                <el-select
                    v-model="value1"
                    @change="choose1"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item1 in this.arr1"
                      :key="item1.value"
                      :label="item1.departmentName"
                      :value="item1"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择分部门" v-show="isShow">
                <el-select
                    v-model="value2"
                    @change="choose2"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item2 in this.arr2"
                      :key="item2.value"
                      :label="item2.departmentName"
                      :value="item2"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择组" v-show="isShow">
                <el-select
                    v-model="value3"
                    @change="choose3"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item3 in this.arr3"
                      :key="item3.value"
                      :label="item3.groupName"
                      :value="item3"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择员工">
                <el-select
                    v-model="value4"
                    @change="choose4"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item4 in this.arr4"
                      :key="item4.value"
                      :label="item4.roleName"
                      :value="item4"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-checkbox v-if="value4" style="margin-left: 48px"
                     @change="handleCheckedTreeExpand($event)" >
          展开/折叠</el-checkbox>
        <el-tree
            v-if="value4"
            :data="treeData"
            :props="treeProps"
            :default-expanded-keys="defaultExpandedKeys"
            node-key="id"
            show-checkbox
            ref="tree"
            style="margin-left: 48px"
        >
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isShowFenpei = false">取 消</el-button>
          <el-button type="primary" @click="Submit">分配</el-button>
        </div>
      </el-dialog>
    </div>


</template>

<script>

import EditSKU from './editSKU.vue'
import { ajaxGet, ajaxPost, Baseurl } from '../../../api/api/api'


export default {
    name: 'skuInfoManagement',
    components: {
        EditSKU,
    },
    computed: {
        // 计算属性，动态计算合并后的类目
        getMergedCategories() {
            return (row) => {
                // 从行数据中获取四个类别的值
                const firstCategory = row.firstCategory || '';
                const secondCategory = row.secondCategory || '';
                const threeCategory = row.threeCategory || '';
                const fourCategory = row.fourCategory || '';

                // 将四个类别的值合并为一个字符串，使用空格分隔，过滤掉空值
                const mergedCategories = [firstCategory, secondCategory, threeCategory, fourCategory].filter(Boolean).join('-->');

                return mergedCategories || '无类别'; // 如果合并后的值为空，返回默认值
            };
        },
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    data() {
        return {
          props: {
            label: 'name',
            children: 'zones'
          },
          defaultExpandedKeys:[],
          companyId:'',
          departmentId:'',
          departmentChildId:'',
          gid:'',
          rid:'',
          isShowFenpei:false,
          isShow: true,
          arr1: '',
          arr2: '',
          arr3: '',
          arr4: '',
          value1: '',
          value2: '',
          value3: '',
          value4: '',
            currentPage: 1,
            size: 10,
            count: 1,
            selectForm: {
                input: '',
                firstCategory: '',
                secondCategory: '',
                threeCategory: '',
                fourCategory: '',
            },
            summarylist: [],
            highlight: true,
            filterText: '',
            treeData: [],  //处理后的数据
            treeProps: {
                children: "children",  //子节点字段名
                label: node => {
                    // 根据节点的 level 动态选择显示的字段名
                    switch (node.level) {
                        case 1:
                        return node.firstCategory;
                        case 2:
                        return node.secondCategory;
                        case 3:
                        return node.threeCategory;
                        case 4:
                        return node.fourCategory;
                        default:
                        return '';
                    }
                },
            },
            iscenter: {
                textAlign: 'center',
                background: '#f8f8f8',
                color: '#232323',
            },
            loading: false,
            isExpandAll:false
        }
    },
    created() {
        this.str = JSON.parse(localStorage.getItem('role'))
        this.staffId = this.str.rid
         this.companyId = this.str.company_id
        this.getTreedata()
      //  this.getTongTuoProducts()
    },
    methods: {
      handleCheckedTreeExpand(val){
        if (val){
          this.defaultExpandedKeys = this.$refs.tree.getCheckedNodes(false, false).map(
              i => i.id)
        } else {
          let treeList = this.treeData;
          for (let i = 0; i < treeList.length; i++) {
            this.$refs.tree.store.nodesMap[treeList[i].id].expanded = val;
          }
        }
      },
      //分配弹窗
      handleFenpei(){
        this.gid = ''
        this.rid = ''
        this.arr1 = []
        this.arr2 = []
        this.arr3 = []
        this.arr4 = []
        this.value1 = ''
        this.value2 = ''
        this.value3 = ''
        this.value4 = ''
        var company_id = {
          company_id: this.companyId,
        }
        ajaxPost(
            Baseurl + 'productTongTuoCategoryController/selectDepartmentListByCompanyId',
            company_id
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.arr1 = res.data.data
            this.isShowFenpei  = true
          }
        })
      },
      choose1(val) {
        this.departmentId = val.did
        this.departmentChildId = ''
        this.gid = ''
        this.rid = ''
        this.arr2 = []
        this.arr3 = []
        this.arr4 = []
        this.value2 = ''
        this.value3 = ''
        this.value4 = ''

        if (val.kind === 0) {
          this.isShow = true
          var company_id = {
            dgrId: val.dgrId,
            system: 2,
          }
          ajaxPost(
              Baseurl + 'roleController/selectNextInfoByDgrId',
              company_id
          ).then((res) => {
            const { code, data } = res.data
            if (code === 200) {
              this.arr2 = res.data.data.next
            }
          })
        } else if (val.kind === 1) {
          this.departmentChildId = ''
          this.gid = ''
          this.isShow = false
          var company_id = {
            dgrId: val.dgrId,
            system: 2,
          }
          ajaxPost(
              Baseurl + 'roleController/selectNextInfoByDgrId',
              company_id
          ).then((res) => {
            const { code, data } = res.data
            if (code === 200) {
              this.arr4 = res.data.data.next
            }
          })
        }
      },
      choose2(val) {
        this.departmentChildId = val.did
        this.gid = ''
        this.rid = ''
        this.arr3 = []
        this.arr4 = []
        this.value3 = ''
        this.value4 = ''
        var company_id = {
          dgrId: val.dgrId,
          system: 3,
        }
        ajaxPost(
            Baseurl + 'roleController/selectNextInfoByDgrId',
            company_id
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.arr3 = res.data.data.next
          }
        })
      },
      choose3(val) {
        this.gid = val.gid
        this.rid = ''
        this.arr4 = []
        this.value4 = ''
        var company_id = {
          dgrId: val.dgrId,
          system: 4,
        }
        ajaxPost(
            Baseurl + 'roleController/selectNextInfoByDgrId',
            company_id
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.arr4 = res.data.data.next
          }
        })
      },
      choose4(val) {
        this.rid = val.rid
        let params = {
          rid:val.rid
        }
        ajaxPost(
            Baseurl + 'productTongTuoCategoryController/selectTongTuoCategoryIdListByRid',
            params
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            data.forEach(item => {
              this.$refs.tree.setChecked(item, true, false);
            });
            this.defaultExpandedKeys = data
          }
        })
      },
        handleCommand(val, row) {
            if (val === 'a') {
                this.$refs.EditSKU.init(row)
            }
        },
        handleSearch() {
            this.currentPage = 1
            this.getTongTuoProducts()
        },
        getTongTuoProducts() {
        if (!this.selectForm.firstCategory){
          this.$message.warning('请选择分配类别后再进行检索！')
          return
        }
            const API = Baseurl + 'productTongTuoController/selectTongTuoProducts'
            const paramsData = {
                page: this.currentPage,
                pageSize: this.size,
                title: this.selectForm.input,
                firstCategory: this.selectForm.firstCategory,
                secondCategory: this.selectForm.secondCategory,
                threeCategory: this.selectForm.threeCategory,
                fourCategory: this.selectForm.fourCategory,
            }
            this.loading = true
            ajaxPost(API, paramsData)
            .then((res) => {
            if (res.data.code === 200) {
                this.summarylist = res.data.data.list
                this.count = res.data.data.total
            } else {
                this.$message.error(res.data.message)
            }
            this.loading = false
            })
        },
        searchReset() {
            this.selectForm.input = ''
            this.currentPage = 1
            this.size = 10
            this.highlight = false
            this.getTongTuoProducts()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getTongTuoProducts()
        },
        handleSizeChange(val) {
            this.size = val
            this.getTongTuoProducts()
        },
        getTreedata() {
            const paramsData = {
              rid: this.staffId
            }
            ajaxPost(
                Baseurl + 'productTongTuoCategoryController/selectTongTuoCategoryListByRid',
                paramsData
            ).then(
                (res) => {
                    const {code, data} = res.data
                    if (code == 200) {
                        this.treeData = data
                    }
                }
            ).catch(
                function(e) {
                    console.log(e);
                }
            )
        },
        allowDrop(draggingNode, dropNode, type) {
            //pid是父节点id
            if (draggingNode.data.parentId === dropNode.data.parentId) {
                return type === "prev" || type === "next";
            } else {
                // 不同级进行处理
                return false;
            }
        },
        filterNode(value, data) {
            if (!value) return true;
            const label = this.getLabelByLevel(data);
            return label.indexOf(value) !== -1;
        },
        getLabelByLevel(node) {
            switch (node.level) {
                case 1:
                    return node.firstCategory;
                case 2:
                    return node.secondCategory;
                case 3:
                    return node.threeCategory;
                case 4:
                    return node.fourCategory;
                default:
                    return '';
            }
        },
        sort(_, dropNode) {
            let obj = {
                params: []
            }
            for (let item of dropNode.parent.childNodes) {
                obj.params.push(item.data);
            }
            this.updateOrderMe(obj)
        },
         handleNodeClick(val) {
            this.highlight = true
            this.selectForm.firstCategory = val.firstCategory
            this.selectForm.secondCategory = val.secondCategory
            this.selectForm.threeCategory = val.threeCategory
            this.selectForm.fourCategory = val.fourCategory
            // 获取产品信息
            this.getTongTuoProducts()
        },
      Submit(){
        let categoryIds = this.$refs.tree.getCheckedNodes(false, true).map(
            i => i.id
        )
        let params = {
          rid:this.rid,
          categoryIds:categoryIds
        }
        ajaxPost(
            Baseurl + '/productTongTuoCategoryController/updateCategoryByRid',
            params
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '分配成功!',
            })
            this.isShowFenpei = false
            this.value1 = ''
            this.arr1 = ''
          }
        })
      }
    }
}
</script>

<style lang="scss" scoped>
    /deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        background-color: #ccc !important;
    }
    /deep/ .el-tree-node__content:hover {
        background: #eee !important;
    }
    .ManagementSKU {
        width: 98%;
        display: flex;
        // padding-bottom: 100px;
        justify-content: space-between;
        height: 100%;
        .block {
            margin-bottom: 20px;
        }
        .left {
            width: 15%;
            float: left;
            border: 1px solid #eee;
            padding: 10px 0;
            border-radius: 4px;
            height: calc(100% - 80px);
            overflow-y: auto;
            .custom-tree-node {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                padding-right: 8px;
                .el-icon-minus {
                    margin: 0 8px;
                }
            }
        }
        .right {
            width: 83%;
            .el-icon-s-data {
            cursor: pointer;
            }
            .summary_complete_bag {
            overflow: hidden;
            .summary_complete {
                overflow: hidden;
                padding: 10px 0;
                border-bottom: 1px #eee solid;
                div {
                padding: 0 10px;
                height: 30px;
                border: #2c8dff 1px solid;
                line-height: 30px;
                text-align: center;
                color: #2c8dff;
                float: left;
                border-radius: 4px;
                cursor: pointer;
                }
                .active {
                background: #2c8dff;
                color: #fff;
                }
            }
            }
            .el-dropdown-link {
            cursor: pointer;
            color: #409EFF;
            }
            .el-icon-arrow-down {
            font-size: 12px;
            }
        }
        .summary_pagenum {
            width: 100%;
            margin-bottom: 10px;
            overflow: hidden;
            background: #f5f5f5;
            .summary_query {
            padding: 5px 10px;
            }
        }
        // .summary_content {
        //     width: 100%;
        //     height: calc(100% - 200px); /* 调整高度，确保容纳 .summary_list */
        //     overflow-y: auto;
        // }

        .summary_pagenum_block {
            width: 1789px;
            padding: 20px;
            position: absolute;
            right: 0;
            bottom: 0;
            background: #fff;
            z-index: 999;
            .el-pagination {
            display: flex;
            justify-content: center;
            }
        }
        /deep/ .el-dialog__header {
            background: rgb(236, 236, 236);
            border-radius: 2px 2px 0 0;
        }
    }
</style>
